import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/overspeedanalysisresultserv'

export default {
  state: {
    state_OverspeedAnalysisResult_GetPageResult: null,
    state_OverspeedAnalysisResult_GetDetailResult: null,
    state_OverspeedAnalysisResult_GetClientPageResult: null,
    state_OverspeedAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_OVERSPEEDANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisResult_GetPageResult = rst;
    },
    SET_OVERSPEEDANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisResult_GetDetailResult = rst;
    },
    SET_OVERSPEEDANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisResult_GetClientPageResult = rst;
    },
    SET_OVERSPEEDANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_OverspeedAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    OverspeedAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    OverspeedAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_OVERSPEEDANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_OVERSPEEDANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_OverspeedAnalysisResult_GetPageResult: state => {
      return state.state_OverspeedAnalysisResult_GetPageResult;
    },
    get_OverspeedAnalysisResult_GetDetailResult: state => {
      return state.state_OverspeedAnalysisResult_GetDetailResult;
    },
    get_OverspeedAnalysisResult_GetClientPageResult: state => {
      return state.state_OverspeedAnalysisResult_GetClientPageResult;
    },
    get_OverspeedAnalysisResult_ExportExcelResult: state => {
      return state.state_OverspeedAnalysisResult_ExportExcelResult;
    },
  }
}